import React, { useState, useRef } from 'react'
import { Icon, Input, Spin, Modal, Tooltip } from "antd"
import { getOrderForPackaging, markOrderPackaged } from '../../../services/api/3dApi'
import { NavLink } from 'react-router-dom'
import MarkPackagedPageSpecifications from './MarkPackagedPageSpecifications'
import MarkPackagedPageDetails from './MarkPackagedPageDetails'
import convertDateOverTime from '../../../helpers/convertDateOverTime'

function MarkPackagedPage() {
    const _input = useRef()
    const [loading, setLoadingState] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [loadingMessage, setLoadingMessage] = useState('Loading...')
    const [actionMessage, setActionMessage] = useState('')
    const [actionMessageType, setActionMessageType] = useState('error')
    const [processingOrder, setProcessingOrder] = useState('')
    const [orders, setOrders] = useState('')
    const [totalItems, setTotalItems] = useState(0)
    const [isMask, setIsMask] = useState(false)
    const [sku, setSku] = useState({})
    const [skuSizes, setSkuSizes] = useState({})
    const [tags, setTags] = useState([])
    const [isMoreThanTwoLines, setIsMoreThanTwoLines] = useState(false)

    const textRef = useRef(null)

    const checkTextHeight = () => {
        if (!!textRef.current) {
            const lineHeight = parseFloat(
                window.getComputedStyle(textRef.current).lineHeight
            )
            const maxHeight = lineHeight * 2
            setIsMoreThanTwoLines(textRef.current.scrollHeight > maxHeight)
        }
    }

    const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
    const isTikTokTag = Array.isArray(tags) && tags.includes('tiktok')
    const isCutoffTag = Array.isArray(tags) && tags.includes('cutoff')
    const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
    const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')

    const setMessage = (msg, type = 'error') => {
        setActionMessage(msg)
        setActionMessageType(type)
    }

    const setLoading = (loading, msg = 'Loading...') => {
        setLoadingState(loading)
        loading && msg && setLoadingMessage(msg)
    }

    const formatMessage = (message) => {
        let vMessage = message && message.replace(/(\d+_\d+)/g, '<strong>$1</strong> ')
        vMessage && (vMessage = <div dangerouslySetInnerHTML={{ __html: vMessage }} />)

        return vMessage
    }

    const getOrder = async (barcodeStr) => {
        setLoading(true, <>Đang lấy thông tin đơn #{barcodeStr}...</>)

        const response = await getOrderForPackaging({ barcodeStr }).catch(e => {
            return {
                error: e.message
            }
        })
        const { data, success, error: message } = response
        const { processingOrder, totalItems, orders, isMask, sku: Sku, skuSizes = {} } = { ...data }
        const { barcode } = { ...processingOrder }
        const { tags: listTags } = { ...barcode }

        if (!processingOrder || !success) {
            const vMessage = formatMessage(message)

            setMessage(vMessage || `Không tìm thấy mã đơn #${barcodeStr}`)
            _resetScanInput(false)
            return Modal.error({
                title: 'Lỗi',
                content: vMessage || `Không tìm thấy mã đơn #${barcodeStr}`,
                //onOk: _resetScanInput(),
                okText: 'Đóng',
            })
        }

        setProcessingOrder(processingOrder)
        setSku(Sku)
        setSkuSizes(skuSizes)
        setOrders(orders)
        setTotalItems(totalItems)
        setIsMask(isMask)
        setTags(listTags)
    }

    const _onSubmit = async (e) => {
        e && e.preventDefault()
        setIsMoreThanTwoLines(false)

        if (!valueInput || !`${valueInput}`.length) {
            return setMessage('Nhập vào mã đơn.')
        }

        reset(false)


        const checkValue = /^#?\d+_\d+$/.test(valueInput)

        if (!checkValue || !valueInput.trim()) {
            const msg = <>Sai định dạng mã đơn, nhập
                đúng <strong>123456_1</strong> hoặc <strong>#123456_1</strong></>
            setMessage(msg)
            setLoading(false)

            return false
        }

        try {
            await getOrder(valueInput.replace(/^#/, ''))
            checkTextHeight()
        } catch (error) {
            setMessage(error)
        } finally {
            setLoading(false)
        }
    }

    const _resetScanInput = (focus = true) => {
        setValueInput('')
        focus && focusInput()
    }

    const focusInput = () => {
        setTimeout(() => {
            _input.current && _input.current.focus()
        }, 300)
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setMessage('')
    }

    const handleMarkPackaged = async () => {
        setLoading(true, <>Đang gửi yêu cầu đánh dấu đơn #{barcodeStr} đã đóng gói...</>)

        const ip_local = sessionStorage.getItem("lanIp")
        try {
            const { success, error, data } = await markOrderPackaged(barcodeStr, { ip_local })

            if (!success) {
                throw new Error(error)
            }

            let {
                message
            } = { ...data }

            if (message) {
                message = formatMessage(message)
            }

            reset()
            setMessage(message || <>Đơn <strong>#{barcodeStr}</strong> đã được đánh dấu đóng gói thành
                công.</>, '')
        } catch (error) {
            setMessage(error.message)
        } finally {
            setLoading(false)
            focusInput()
        }
    }

    const reset = (resetInput = true) => {
        resetInput && _resetScanInput()
        setIsMask(false)
        setTotalItems(0)
        setOrders(false)
        setProcessingOrder(false)
        setMessage('')
        setTags([])
    }

    const _handleInputKeyDown = (e) => {
        if (e.keyCode === 13) {

        } else if (e.keyCode === 27) {

        }
    }

    const onCancel = () => {
        focusInput()
    }

    const barcodeStr = processingOrder && [processingOrder.barcode_number, processingOrder.item_number].join('_')

    // window.addEventListener('load', () => {
    //     console.log({_input})
    //     setTimeout(() => {
    //         _input && _input.current && _input.current.focus()
    //         _onSubmit()
    //     }, 1000)
    // })

    window.onfocus = function () {
        focusInput()
    }

    const { barcode } = { ...processingOrder }
    const { storename, note: noteOrder = '', tags: barcodeTags = [] } = { ...barcode }
    const isSLL = Array.isArray(barcodeTags) && barcodeTags.includes('SLL')

    return (
        <div className="MarkPackagedPage py-5">
            <div className="col-12 mx-auto px-5">
                <div className="row align-items-baseline justify-content-between">
                    <div className='col-7 d-flex justify-content-between align-items-center'>
                        <h1 className="PageTitle d-flex align-items-center flex-wrap">
                            <span className='mr-4' >Đánh dấu đóng gói</span>
                            {isSLL &&
                                <span className="SLL-tag mr-2 mb-0">SLL</span>
                            }
                        </h1>
                        {processingOrder && !!processingOrder.overtime && processingOrder.overtime > 0 &&
                            <div>
                                <h4
                                    className="mb-0 mt-2 btn"
                                    style={{
                                        background: 'rgba(255 77 80)',
                                        color: 'white', cursor: 'auto',
                                    }}
                                >
                                    QUÁ HẠN <label
                                        className="font-weight-bold my-0">{convertDateOverTime(processingOrder.overtime)}</label>
                                </h4>
                            </div>
                        }
                        {!!processingOrder && !!processingOrder.remaining_time && (processingOrder.remaining_time > 0 && processingOrder.remaining_time <= 1) &&
                            <div>
                                <h4
                                    className="mb-0 mt-2 btn"
                                    style={{
                                        background: '#ffcd3a',
                                        color: 'white', cursor: 'auto',
                                    }}
                                >
                                    Sắp quá hạn <label
                                        className="font-weight-bold my-0">{convertDateOverTime(-processingOrder.remaining_time)}</label>
                                </h4>
                            </div>
                        }
                    </div>
                    <div className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6" style={{zIndex: 2}}>
                        <NavLink exact to="/packing-item" className="nav-link p-0">
                            Danh sách đóng gói
                        </NavLink>
                    </div>
                </div>
                <div className="site-layout-background pb-4">
                    <div className="UpdateOrderPackaged">
                        <div className="UpdateOrderPackagedPage">
                            <div className="position-relative">
                                <Spin spinning={loading} tip={loadingMessage}>
                                    <form onSubmit={_onSubmit} className="mb-4 row">
                                        <div className="col-md-7">
                                            <div className="Input">
                                                <Input
                                                    value={valueInput.toUpperCase()}
                                                    style={{ fontSize: 36, height: "auto" }}
                                                    ref={_input}
                                                    autoFocus={true}
                                                    placeholder="Nhập item cần đánh dấu"
                                                    onChange={_handleChangeScan}
                                                    onKeyDown={_handleInputKeyDown}
                                                />

                                                {
                                                    valueInput && !loading &&
                                                    <Icon
                                                        type="close-circle"
                                                        className="position-absolute cursor-pointer text-dark IconInput"
                                                        onClick={_resetScanInput}
                                                    />
                                                }

                                                {
                                                    loading &&
                                                    <Icon type="sync" spin className="position-absolute IconInput" />
                                                }

                                            </div>

                                            {
                                                actionMessage && <div className={
                                                    actionMessageType === 'error'
                                                        ? 'ErrorMsg alert alert-danger'
                                                        : 'SuccessMsg alert alert-success'
                                                }>{actionMessage}</div>
                                            }

                                            {
                                                !!processingOrder && !!orders &&
                                                <MarkPackagedPageDetails processingOrder={processingOrder}
                                                    sku={sku}
                                                    totalItems={totalItems} orders={orders}
                                                    isMask={isMask}
                                                    loadging={loading}
                                                    reset={reset}
                                                    onMarkPackaged={handleMarkPackaged}
                                                    onCancel={onCancel} />
                                            }
                                        </div>
                                        <div className="col-md-5 position-relative">
                                            <div className="d-flex Fastproduction w-100" style={{ top: -60 }}>
                                                {
                                                    isFastProductionTag &&
                                                    <span className='mr-3'>Sản xuất nhanh</span>
                                                }
                                                {
                                                    isTikTokTag &&
                                                    <span className='mr-3 tiktok'>TIKTOK</span>
                                                }
                                                {
                                                    isCutoffTag &&
                                                    <span className='mr-3'>Cutoff</span>
                                                }
                                                {
                                                    isCutOffNoel &&
                                                    <span className='mr-3'>Cutoff noel</span>
                                                }
                                                {
                                                    isCutOffNewYear &&
                                                    <span className='mr-3'>Cutoff new year</span>
                                                }
                                            </div>
                                            {storename === 'mt80szd' &&
                                                <h1 className='text-danger'>Sản phẩm VIP - QC, đóng gói tách riêng</h1>
                                            }
                                            {
                                                !!noteOrder &&
                                                <h1
                                                    className='text-danger mr-3 position-absolute'
                                                    ref={textRef}
                                                    style={{
                                                        fontSize: '25px',
                                                        cursor: isMoreThanTwoLines ? 'pointer' : 'unset',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    {
                                                        isMoreThanTwoLines ?
                                                            <Tooltip title={noteOrder}>
                                                                Note: {`${noteOrder.slice(0, 50)}...`}
                                                            </Tooltip> :
                                                            `Note: ${noteOrder}`
                                                    }
                                                </h1>
                                            }
                                            {
                                                !!processingOrder &&
                                                <MarkPackagedPageSpecifications
                                                    sku={sku}
                                                    isMoreTag={storename === 'mt80szd'}
                                                    orders={orders}
                                                    isMask={isMask}
                                                    skuSizes={skuSizes}
                                                    noteOrder={noteOrder}
                                                    totalItems={totalItems}
                                                    processingOrder={processingOrder}
                                                />
                                            }
                                        </div>
                                    </form>
                                </Spin>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarkPackagedPage
